import * as apiGetVenues from '@/api/marcom/getVenues';
import * as apiGetLocations from '@/api/marcom/getLocations';
import * as apiFindVenues from '@/api/marcom/findVenues';
import * as apiGetVenueSetups from '@/api/marcom/getVenueSetups';
import * as apiGetVenueSetup from '@/api/marcom/getVenueSetup';
import * as apiGetActiveVenueSetup from '@/api/marcom/getActiveVenueSetup';
import * as apiGetVenueSetupCaledarEntries from '@/api/marcom/getVenueSetupCalendarEntries';
import * as apiUpdateVenue from '@/api/marcom/updateVenue';
import * as apiPostVenue from '@/api/marcom/postVenue';
import * as apiPostVenueSetup from '@/api/marcom/postVenueSetup';
import * as apiPostSection from '@/api/marcom/postSection';
import * as apiPostCalendarDatesByDateList from '@/api/marcom/postCalendarDatesByDateList';
import * as apiPostCalendarDatesByWeeklyInterval from '@/api/marcom/postCalendarDatesByWeeklyInterval';
import * as apiPostCalendarDatesByYearlyInterval from '@/api/marcom/postCalendarDatesByYearlyInterval';
import * as apiPostTable from '@/api/marcom/postTable';
import * as apiDeleteTable from '@/api/marcom/deleteTable';
import * as apiDeleteSetup from '@/api/marcom/deleteSetup';
import * as apiDeleteSection from '@/api/marcom/deleteSection';
import * as apiPostVenueSetupCalendarEntry from '@/api/marcom/postVenueSetupCalendarEntry';
import * as apiPatchVenueSetupCalendarEntry from '@/api/marcom/patchVenueSetupCalendarEntry';
import * as apiPutVenueSetup from '@/api/marcom/putVenueSetup';
import * as apiPutVenueSection from '@/api/marcom/putVenueSection';
import * as apiPutVenueTable from '@/api/marcom/putVenueTable';
import * as apiGetVenueSetupProducts from '@/api/marcom/getVenueSetupProducts';
import * as apiGetTags from '@/api/marcom/getTags';
import * as apiGetEvents from '@/api/marcom/getEvents';
import * as apiGetEventsByDate from '@/api/marcom/getEventsByDate'
import * as apiPostEvent from '@/api/marcom/postEvent';
import * as apiDeleteEvent from '@/api/marcom/deleteEvent';
import * as apiPutEvent from '@/api/marcom/putEvent';
import * as apiPutVenueSetupProducts from '@/api/marcom/putVenueSetupProducts';
import * as apiPostVenueNote from '@/api/marcom/postVenueNote';
import * as apiGetVenueNotes from '@/api/marcom/getVenueNotes';
import * as apiPatchVenueBookingsClosedNote from '@/api/marcom/patchVenueBookingsClosedNote';
import * as apiPostGuestListItem from '@/api/marcom/postGuestListItem';
import * as apiGetGuestListItems from '@/api/marcom/getGuestListItems';
import * as apiPutGuestListItem from '@/api/marcom/putGuestListItem';
import * as apiPatchGuestListItemArrivalState from '@/api/marcom/patchGuestListItemArrivalState';
import * as apiPutFloorplan from '@/api/marcom/putVenueSetupFloorplan';
import * as apiGetFloorplan from '@/api/marcom/getSetupFloorplan';
import * as apiSwapCalendarEntries from '@/api/marcom/swapCalendarEntries';
import * as apiCopyVenueSetup from '@/api/marcom/postCopyVenueSetup';
import { apiGetCountryCodes, apiGetTimeZones, apiGetTimeZonesByCountryCode } from '@/api/marcom/time-zones/index.js';
import * as apiPostCreateReservationsPdf from '@/api/marcom/postCreateReservationsPdf';
import * as apiGetBookingPercentageMonth from '@/api/marcom/getBookingPercentageMonth';
import * as apiPostBookingPercentageByVenues from '@/api/marcom/postBookingPercentageByVenues';
import * as apiPatchVenueTableActive from '@/api/marcom/patchVenueTableActive';
import * as apiPatchGuestListItemArrivalCount from '@/api/marcom/patchGuestListItemArrival'
import * as apiPatchGuestListItemArrivalInfo from '@/api/marcom/patchGuestListItemArrivalInfo'

import * as _ from "lodash";
import { VenueSetup } from './data-model/venue-details/venue-setup.js';
import { VenueDetails } from './data-model/venue-details/venue-details.js';
import { VenueSetupCalendarEntry } from './data-model/calendar/venue-setup-calendar-entry.js';
import { GuestListItem } from './data-model/guest-list-items/guest-list-item.js';
import { VenueNote } from './data-model/venue-notes/venue-note.js';
import { CreateUpdateGuestListItemCommand } from './data-model/guest-list-items/queries-and-commands/create-update-guest-list-item-command.js';
import { GetVenueNotesQuery } from './data-model/venue-notes/queries-and-commands/get-venue-notes-query.js';
import { ChangeGuestListItemArrivalStateCommand } from './data-model/guest-list-items/queries-and-commands/change-guest-list-item-arrival-state-command.js';
import { GetGuestListItemsQuery } from './data-model/guest-list-items/queries-and-commands/get-guest-list-items-query.js';
import { BookingTag } from './data-model/bookings/booking-tag.js';


export const ACTIONS = {
  AddDefaultCalendarEntry: 'AddDefaultCalendarEntry',
  AddGuestListItem: 'AddGuestListItem',
  AddMinSpendPolicy: 'AddMinSpendPolicy',
  AddSection: 'AddSection',
  AddSetup: 'AddSetup',
  AddTable: 'AddTable',
  AddVenue: 'AddVenue',
  AddPartialArraival: 'AddPartialArrival',
  AddVenueNote: 'AddVenueNote',
  ChangeGuestListItemArrivalState: 'ChangeGuestListItemArrivalState',
  CopyVenueSetup: 'CopyVenueSetup',
  DeleteMinSpendPolicy: 'DeleteMinSpendPolicy',
  DeleteProduct: 'DeleteProduct',
  DeleteSection: 'DeleteSection',
  DeleteSetup: 'DeleteSetup',
  DeleteTable: 'DeleteTable',
  FindActiveVenue: 'FindActiveVenue',
  GetActiveSetup: 'GetActiveSetup',
  GetBookingPercentageByDateAndVenueDetailIds: 'GetBookingPercentageByDateAndVenueDetailIds',
  GetBookingPercentageMonth: 'GetBookingPercentageMonth',
  GetCalendarEntriesByActiveVenueDetails: 'GetCalendarEntriesByActiveVenueDetails',
  GetCountryCodes: 'GetCountryCodes',
  GetFloorplan: 'GetFloorplan',
  GetGuestListItems: 'GetGuestListItems',
  GetLocations: 'GetLocations',
  GetProductsBySetup: 'GetProductsBySetup',
  GetTimeZonesByCountryCode: 'GetTimeZonesByCountryCode',
  GetVenueNotes: 'GetVenueNotes',
  GetVenues: 'GetVenues',
  GetVenueSetup: 'GetVenueSetup',
  GetVenueSection: 'GetVenueSection',
  GetBookingTags: 'GetBookingTags',
  GetEvents: 'GetEvents',
  GetEventsByDate: 'GetEventsByDate',
  SaveEvent: 'SaveEvent',
  DeleteEvents: 'DeleteEvents',
  GetVenueSetupsForActiveVenueDetails: 'GetVenueSetupsForActiveVenueDetails',
  MoveTables: 'MoveTables',
  PostCalendarDatesByDateList: 'PostCalendarDatesByDateList',
  PostCalendarDatesByWeeklyInterval: 'PostCalendarDatesByWeeklyInterval',
  PostCalendarDatesByYearlyInterval: 'PostCalendarDatesByYearlyInterval',
  PostCreateReservationsPdf: 'PostCreateReservationsPdf',
  SaveCalendarEntry: 'SaveCalendarEntry',
  SaveProducts: 'SaveProducts',
  SetVenueTableActive: 'SetVenueTableActive',
  SwapCalendarEntries: 'SwapCalendarEntries',
  UpdateFloorplan: 'UpdateFloorplan',
  UpdateGuestListItem: 'UpdateGuestListItem',
  UpdateMinSpendPolicy: 'UpdateMinSpendPolicy',
  UpdateSection: 'UpdateSection',
  UpdateSetup: 'UpdateSetup',
  UpdateTable: 'UpdateTable',
  UpdateVenue: 'UpdateVenue',
  UpdateVenueBookingsClosedNote: 'UpdateVenueBookingsClosedNote',
  UpdateVenueSetupCalendarEntry: 'UpdateVenueSetupCalendarEntry',
  UpdateGuestListItemPartialArrival: "UpdateGuestListItemPartialArrival"
};

export const MUTATIONS = {
  AddedSection: 'AddedSection',
  AddedVenueSetup: 'AddedVenueSetup',
  AddGuestListItem: 'AddGuestListItem',
  AddVenueNote: 'AddVenueNote',
  GotActiveVenue: 'GotActiveVenue',
  GotVenueSetupsForActiveVenueDetails: 'GotVenueSetupsForActiveVenueDetails',
  GotCountryCodes: 'GotCountryCodes',
  GotGuestListItems: 'GotGuestListItems',
  GotLocations: 'GotLocations',
  GotVenueNotes: 'GotVenueNotes',
  GotVenues: 'GotVenues',
  GotBookingTags: 'GotBookingTags',
  GotVenueSetupCalendarEntries: 'GotVenueSetupCalendarEntries',
  GotVenueSections: 'GotVenueSections',
  IsLoadingActiveVenue: 'IsLoadingActiveVenue',
  IsLoadingLocations: 'IsLoadingLocations',
  IsLoadingVenues: 'IsLoadingVenues',
  UpdateVenue: 'UpdateVenue',
  SetSelectedSetup: 'SetSelectedSetup',
};

export default {
  namespaced: true,
  state: {
    isLoadingVenues: false,
    isLoadingVenueById: false,
    isLoadingActiveVenue: false,
    isLoadingLocations: false,
    venues: [],
    locations: [],
    activeVenue: null,
    activeVenueSetups: null,
    guestListItems: [],
    venueNotes: [],
    venueSections: [],
    venueSetupCalendarEntries: [],
    tags: [],
    selectedSetup: undefined,
  },
  getters: {
    activeVenue: state => {
      return state.activeVenue;
    },
    activeVenueSetups: state => {
      return state.activeVenueSetups ? state.activeVenueSetups.filter(t => t.deleted === null) : [];
    },
    activeVenueSetupCalendarEntries: state => {
      return state.venueSetupCalendarEntries;
    },
    countryCodes: state => {
      return state.countryCodes;
    },
    isLoadingActiveVenue: state => {
      return state.isLoadingActiveVenue;
    },
    isLoadingLocations: state => {
      return state.isLoadingLocations;
    },
    locations: state => {
      return state.locations;
    },
    venues: state => {
      return state.venues;
    },
    allBookingTags: state => {
      return state.tags
    },
    themeBookingTags: (state, getters) => {
      return getters.allBookingTags.filter(
        (twt) => twt.isThemeTag()
      );
    },
    bookingTypeBookingTags: (state, getters) => {
      return getters.allBookingTags.filter(
        (twt) => twt.isBookingTypeTag()
      );
    },
    getBookingTagTranslation: (state, getters) => tag => {
      const tagWithTranslations = getters.allBookingTags.find(twt => twt.tag === tag);
      if(tagWithTranslations)
        return tagWithTranslations.getTranslation();
      if (_.startsWith(tag, `${BookingTag.THEME_OTHER_PREFIX}|`)) {
        return tag.substring(`${BookingTag.THEME_OTHER_PREFIX}|`.length);
      }
      return tag;
    },
    selectedSetup: state => {
      return state.selectedSetup;
    },
    isOnlineBookingClosed: state => {
      return _.findIndex(state.venueNotes, (n) => n.bookingClosed === true) >= 0;
    }
  },
  mutations: {
    [MUTATIONS.GotGuestListItems](state, guestListItems) {
      state.guestListItems = guestListItems;
    },
    [MUTATIONS.GotVenueNotes](state, venueNotes) {
      state.venueNotes = venueNotes;
    },
    [MUTATIONS.GotVenues](state, venues) {
      state.venues = venues;
    },
    [MUTATIONS.GotActiveVenue](state, venue) {
      state.activeVenue = venue;
    },
    [MUTATIONS.GotVenueSetupsForActiveVenueDetails](state, setups) {
      state.activeVenueSetups = setups;
      const setupIds = state.activeVenueSetups.map(s => s.id);
      if (!state.selectedSetup || !setupIds.includes(state.selectedSetup.id)) {
        state.selectedSetup = state.activeVenueSetups[0];
      }
      else {
        state.selectedSetup = state.activeVenueSetups.find(s => s.id === state.selectedSetup.id);
      }
    },
    [MUTATIONS.SetSelectedSetup](state, venueSetupId) {
      if (!state.activeVenueSetups || state.activeVenueSetups.length === 0) {
        state.selectedSetup = undefined;
        return;
      }

      const setupIds = state.activeVenueSetups.map(s => s.id);
      if (setupIds.includes(venueSetupId.id)) {
        state.selectedSetup = state.activeVenueSetups.find(s => s.id === venueSetupId.id);
      }
      else
        state.selectedSetup = state.activeVenueSetups[0];
    },
    [MUTATIONS.GotLocations](state, locations) {
      state.locations = locations;
    },
    [MUTATIONS.GotVenueSetupCalendarEntries](state, calendarEntries) {
      state.venueSetupCalendarEntries = calendarEntries;
    },
    [MUTATIONS.IsLoadingVenues](state, loading) {
      state.isLoadingVenues = loading;
    },
    [MUTATIONS.IsLoadingActiveVenue](state, loading) {
      state.isLoadingActiveVenue = loading;
    },
    [MUTATIONS.IsLoadingLocations](state, loading) {
      state.isLoadingLocations = loading;
    },
    [MUTATIONS.GotCountryCodes](state, countryCodes) {
      state.countryCodes = countryCodes;
    },
    [MUTATIONS.GotBookingTags](state, tags) {
      state.tags = tags;
    },
    [MUTATIONS.GotVenueSections](state, sections) {
      for (const section of sections) {
        state.venueSections.push(section);
      }
    },
  },
  actions: {
    async [ACTIONS.AddGuestListItem]({ dispatch, getters }, guestListItem) {
      const command = new CreateUpdateGuestListItemCommand(
        guestListItem.venueDetailsId,
        guestListItem.guestProfileId,
        guestListItem.fullName,
        guestListItem.email,
        guestListItem.phoneNumber,
        guestListItem.date,
        guestListItem.guestCount,
        guestListItem.note
      );

      var result = await apiPostGuestListItem.post(command);
      if (result) {
        let query = new GetGuestListItemsQuery(guestListItem.date, getters.activeVenue.venueDetailsId);
        await dispatch(ACTIONS.GetGuestListItems, query);
      }
      return result;
    },
    async [ACTIONS.GetGuestListItems]({ commit }, query) {
      let result = await apiGetGuestListItems.get(query);

      if (result) {
        result = result.map(r => GuestListItem.fromJSON(r));
        commit(MUTATIONS.GotGuestListItems, result);
      }
      return result;
    },
    async [ACTIONS.UpdateGuestListItem]({ dispatch, getters }, guestListItem) {
      console.log("GUESTLISTITEM", guestListItem)
      let command = new CreateUpdateGuestListItemCommand(
        guestListItem.venueDetailsId,
        guestListItem.guestProfileId,
        guestListItem.fullName,
        guestListItem.email,
        guestListItem.phoneNumber,
        guestListItem.date,
        guestListItem.guestCount,
        guestListItem.note
      );
      console.log("GUESTLISTITEM-COMMAND", command)
      command.arrivalState = guestListItem.arrivalState;
      command.requestState = guestListItem.requestState;
      var result = await apiPutGuestListItem.put(guestListItem.id, command);
      if (result) {
        let query = new GetGuestListItemsQuery(guestListItem.date, getters.activeVenue.venueDetailsId);
        await dispatch(ACTIONS.GetGuestListItems, query);
      }
      return result;
    },
    async [ACTIONS.ChangeGuestListItemArrivalState]({ dispatch, getters }, { guestListItem, rejectionNote }) {
      let command = new ChangeGuestListItemArrivalStateCommand(
        guestListItem.arrivalState,
        rejectionNote
      );
      var result = await apiPatchGuestListItemArrivalState.patch(guestListItem.id, command);
      if (result) {
        let query = new GetGuestListItemsQuery(guestListItem.date, getters.activeVenue.venueDetailsId);
        await dispatch(ACTIONS.GetGuestListItems, query);
      }
      return result;
    },
    async [ACTIONS.AddPartialArraival]({ dispatch, getters }, { guestListItem, arrival }) {
      var result = await apiPatchGuestListItemArrivalCount.patch(guestListItem.id, arrival);
      if (result == ""){
          let query = new GetGuestListItemsQuery(guestListItem.date, getters.activeVenue.venueDetailsId);
          await dispatch(ACTIONS.GetGuestListItems, query)
      }
      return result
    },
    async [ACTIONS.UpdateGuestListItemPartialArrival]({ dispatch, getters }, { guestListItem, arrival }) {
      var result = await apiPatchGuestListItemArrivalInfo.patch(guestListItem.id, arrival);
      if (result == ""){
          let query = new GetGuestListItemsQuery(guestListItem.date, getters.activeVenue.venueDetailsId);
          await dispatch(ACTIONS.GetGuestListItems, query)
      }
      return result
    },
    async [ACTIONS.AddVenueNote]({ dispatch, getters }, venueNote) {
      let result = await apiPostVenueNote.post(venueNote);
      if (result) {
        let query = new GetVenueNotesQuery(venueNote.date, getters.activeVenue.venueDetailsId);
        await dispatch(ACTIONS.GetVenueNotes, query);
      }
      return result;
    },
    async [ACTIONS.GetVenueNotes]({ commit }, query) {
      let result = await apiGetVenueNotes.get(query);

      if (result) {
        result = result.map(r => VenueNote.fromJSON(r));
        commit(MUTATIONS.GotVenueNotes, result)
      }
      return result;
    },
    async [ACTIONS.UpdateVenueBookingsClosedNote]({ dispatch, getters }, command) {
      let result = await apiPatchVenueBookingsClosedNote.patch(command);
      if (result) {
        let query = new GetVenueNotesQuery(command.date, getters.activeVenue.venueDetailsId);
        await dispatch(ACTIONS.GetVenueNotes, query);
      }
      return result;
    },
    async [ACTIONS.GetLocations]({ commit }) {
      if (this.locations && this.locations.length > 0)
        return;

      commit(MUTATIONS.IsLoadingLocations, true);
      const result = await apiGetLocations.get();

      if (result) {
        commit(MUTATIONS.GotLocations, result)
      }

      commit(MUTATIONS.IsLoadingLocations, false)
    },
    async [ACTIONS.GetVenues]({ commit }) {
      commit(MUTATIONS.IsLoadingVenues, true);

      let result = await apiGetVenues.get();
      if (result) {
        result = result.map(r => VenueDetails.fromJSON(r));
      }

      if (result) {
        commit(MUTATIONS.GotVenues, result)
      }

      commit(MUTATIONS.IsLoadingVenues, false);

      return result;
    },
    async [ACTIONS.GetActiveSetup]({ commit }, setupQuery) {
      let result = await apiGetActiveVenueSetup.get(setupQuery);
      if (result)
        result = VenueSetup.fromJSON(result);
      return result;
    },
    async [ACTIONS.GetVenueSetup]({ commit }, setupId) {
      let result = await apiGetVenueSetup.get(setupId);
      if (result)
        result = VenueSetup.fromJSON(result);
      return result;
    },
    async [ACTIONS.GetBookingTags]({ commit }) {
      if (this.state.marcom.tags.length > 0)
        return this.state.marcom.tags;
      let result = await apiGetTags.get();
      if (result)
        result = result.map(t => BookingTag.fromJSON(t));
      commit(MUTATIONS.GotBookingTags, result);
      return result;
    },
    async [ACTIONS.GetEvents]({ commit }, venueDetailsId) {
      const result = await apiGetEvents.get(venueDetailsId);
      return result;
    },
    async [ACTIONS.GetEventsByDate]({ commit }, eventQuery) {

      const result = await apiGetEventsByDate.get(eventQuery.venueDetailsId, eventQuery.from, eventQuery.to);
      return result;
    },
    async [ACTIONS.SaveEvent]({ commit }, event) {

      if (!event.eventId) {
        const result = await apiPostEvent.post(event);
        return result;
      }
      else {
        const result = await apiPutEvent.put(event);
        return result;
      }
    },
    async [ACTIONS.DeleteEvent]({ commit }, eventId) {
      const result = await apiDeleteEvent.del(eventId);
      return result;
    },
    async [ACTIONS.CopyVenueSetup]({ dispatch }, setupCommand) {
      const result = await apiCopyVenueSetup.post(setupCommand.venueSetupId, setupCommand.setupName);
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      await dispatch(ACTIONS.GetCalendarEntriesByActiveVenueDetails);
      return result;
    },
    async [ACTIONS.FindActiveVenue]({ commit, dispatch }, venueQuery) {
      commit(MUTATIONS.IsLoadingActiveVenue, true);

      const result = await apiFindVenues.get(venueQuery.venuePortalId);

      if (result && result.length > 0) {
        var venue = VenueDetails.fromJSON(result[0]);

        commit(MUTATIONS.GotActiveVenue, venue);

        await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
        await dispatch(ACTIONS.GetCalendarEntriesByActiveVenueDetails);
      }

      commit(MUTATIONS.IsLoadingActiveVenue, false);
    },
    async [ACTIONS.GetVenueSetupsForActiveVenueDetails]({ commit }) {
      let setupResult = await apiGetVenueSetups.get(this.state.marcom.activeVenue.id);
      if (setupResult)
        setupResult = setupResult.map(setup => {
          return VenueSetup.fromJSON(setup);
        });

      commit(MUTATIONS.GotVenueSetupsForActiveVenueDetails, setupResult);
    },
    async [ACTIONS.GetProductsBySetup]({ commit }, setup) {
      var products = await apiGetVenueSetupProducts.get(setup.id);
      return products;
    },
    async [ACTIONS.SaveProducts]({ commit }, products) {
      var result = null;
      result = await apiPutVenueSetupProducts.put(products);
      return result;
    },
    async [ACTIONS.UpdateFloorplan]({ dispatch }, floorplanCommand) {
      var result = await apiPutFloorplan.put(floorplanCommand.venueSetupId, floorplanCommand.floorplan);
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      return result;
    },
    async [ACTIONS.GetFloorplan]({ commit }, venueSetupId) {

      var result = await apiGetFloorplan.get(venueSetupId);

      //Try to map tables to floorplan tables
      if (this.state.marcom.activeVenueSetups) {

        var setup = this.state.marcom.activeVenueSetups.find(vs => vs.id == venueSetupId);

        if (setup) {
          var setupTables = setup.venueSections.map(s => s.venueTables).flat();
          for (const table of result.tables) {
            var setupTable = setupTables.find(st => st.id == table.tableId);
            if (setupTable)
              table.name = setupTable.name;
          }
        }
      }

      return result;
    },
    async [ACTIONS.GetVenueSection]({ commit }, sectionQuery) {
      var result = this.state.marcom.venueSections.find(vs => (vs.id === sectionQuery.venueSectionId));

      if (result === undefined) {
        const setups = await apiGetVenueSetup.get(sectionQuery.venueSetupId);
        commit(MUTATIONS.GotVenueSections, setups.venueSections);
        result = setups.venueSections.find(vs => (vs.id === sectionQuery.venueSectionId));
      }
      return result;
    },
    async [ACTIONS.UpdateVenue]({ commit, dispatch }, venue) {
      commit(MUTATIONS.IsLoadingActiveVenue, true);

      try {
        const result = await apiUpdateVenue.put(venue);
        await dispatch(ACTIONS.FindActiveVenue, { venuePortalId: venue.venuePortalId });
        return result;
      }
      catch (err) {
        throw err;
      }
      finally {
        commit(MUTATIONS.IsLoadingActiveVenue, false);
      }
    },
    async [ACTIONS.AddVenue]({ commit, dispatch }, venueCommand) {
      commit(MUTATIONS.IsLoadingActiveVenue, true);

      //First, create the venue
      var venue = {
        locationId: { id: venueCommand.locationId },
        name: venueCommand.name,
        shortName: venueCommand.shortName,
        address: venueCommand.address,
        description: "Description coming soon",
        image: venueCommand.image != null && venueCommand.image != "" ? venueCommand.image : "https://media-exp1.licdn.com/dms/image/C560BAQG5PhjfbxSDoA/company-logo_200_200/0/1519909164046?e=2159024400&v=beta&t=6r5LPCw8ESHVwNs7GztKL9SDuM-Q7lVa80W71hI_tHc",
        logo: "https://media-exp1.licdn.com/dms/image/C560BAQG5PhjfbxSDoA/company-logo_200_200/0/1519909164046?e=2159024400&v=beta&t=6r5LPCw8ESHVwNs7GztKL9SDuM-Q7lVa80W71hI_tHc",
        images: [],
        tags: [],
        startTimeOfDay: "10:00",
        venuePortalId: venueCommand.venuePortalId,
        iso3166CountryCode: venueCommand.iso3166CountryCode,
        timeZoneCode: venueCommand.timeZoneCode,
      }

      const result = await apiPostVenue.put(venue);
      //venue.id = result.id;

      //Next, create the setup
      var venueSetup = {
        name: venueCommand.setupName,
        venueDetailsId: {
          id: result.id
        }
      }

      await apiPostVenueSetup.post(venueSetup);
      await dispatch(ACTIONS.FindActiveVenue, { venuePortalId: venue.venuePortalId });
      commit(MUTATIONS.IsLoadingActiveVenue, false);

      return result;
    },
    async [ACTIONS.GetCalendarEntriesByActiveVenueDetails]({ commit }) {
      var calendarEntries = await apiGetVenueSetupCaledarEntries.get(this.state.marcom.activeVenue.id);
      calendarEntries = calendarEntries.map(ce => VenueSetupCalendarEntry.fromJSON(ce));
      commit(MUTATIONS.GotVenueSetupCalendarEntries, calendarEntries);
    },
    async [ACTIONS.AddDefaultCalendarEntry]({ commit, dispatch }, calendarEntryCommand) {
      //Set default calendar entry
      var calendarEntry = {
        venueSetupId: {
          id: calendarEntryCommand.setupId
        },
        isActive: true,
        priority: 0,

        fromDate: "2021-01-01",
        fromTime: "10:00",
        toDate: "2031-01-01",
        toTime: "10:00"
      }

      const calendarEntryResult = await apiPostVenueSetupCalendarEntry.post(calendarEntry);
      calendarEntry.id = calendarEntryResult.id;
      calendarEntry = VenueSetupCalendarEntry.fromJSON(calendarEntry);
      return calendarEntry;
    },
    async [ACTIONS.AddSetup]({ dispatch, commit }, setupCommand) {

      //Next, create the setup
      var venueSetup = {
        name: setupCommand.setupName,
        venueDetailsId: setupCommand.venueDetailsId
      };

      const venueSetupId = await apiPostVenueSetup.post(venueSetup);
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      await dispatch(ACTIONS.GetCalendarEntriesByActiveVenueDetails);
      commit(MUTATIONS.SetSelectedSetup, venueSetupId);
    },
    async [ACTIONS.UpdateSetup]({ dispatch }, venueSetupCommand) {
      const setupResult = await apiPutVenueSetup.put(venueSetupCommand.venueSetup);
      await apiPutVenueSetupProducts.put(venueSetupCommand.venueSetup, venueSetupCommand.products);
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      return setupResult;
    },
    async [ACTIONS.UpdateSection]({ dispatch }, venueSectionCommand) {
      const sectionResult = await apiPutVenueSection.put(venueSectionCommand.venueSetupId, venueSectionCommand.venueSection);
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      return sectionResult;
    },
    async [ACTIONS.UpdateTable]({ dispatch }, venueTableCommand) {
      const tableResult = await apiPutVenueTable.put(venueTableCommand.venueSetupId, venueTableCommand.venueSectionId, venueTableCommand.venueTable);
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      return tableResult;
    },
    async [ACTIONS.SetVenueTableActive]({ commit }, { venueSetupId, venueSectionId, venueTableId, isActive }) {
      await apiPatchVenueTableActive.patch(venueSetupId, venueSectionId, venueTableId, isActive);
    },
    async [ACTIONS.UpdateVenueSetupCalendarEntry]({ commit }, calendarEntry) {
      const calendarWeekResult = await apiPatchVenueSetupCalendarEntry.patch(calendarEntry.id, calendarEntry);
    },
    async [ACTIONS.AddSection]({ commit, dispatch }, sectionCommand) {
      var section = {
        name: sectionCommand.sectionName
      }

      const sectionResult = await apiPostSection.put(sectionCommand.venueSetupId, section);

      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);

      return section;
    },
    async [ACTIONS.PostCalendarDatesByWeeklyInterval]({ commit, dispatch }, entryCommand) {
      //commit(MUTATIONS.IsLoadingActiveVenue, true);

      var calendarDatesByWeeklyEntry = {
        repeatEveryCount: 1,
        repeatOnDays: entryCommand.repeatOnDays,
        priority: 0
      }

      const sectionResult = await apiPostCalendarDatesByWeeklyInterval.patch(entryCommand.calenderEntryId, calendarDatesByWeeklyEntry);
      //commit(MUTATIONS.IsLoadingActiveVenue, false);
      //await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      await dispatch(ACTIONS.GetCalendarEntriesByActiveVenueDetails);
      return sectionResult;
    },
    async [ACTIONS.PostCalendarDatesByYearlyInterval]({ commit, dispatch }, entryCommand) {
      //commit(MUTATIONS.IsLoadingActiveVenue, true);

      var calendarDatesByYearlyEntry = {
        repeatEveryCount: 1,
        repeatOnDates: entryCommand.dates,
        priority: 0
      }

      const sectionResult = await apiPostCalendarDatesByYearlyInterval.patch(entryCommand.calenderEntryId, calendarDatesByYearlyEntry);
      //commit(MUTATIONS.IsLoadingActiveVenue, false);
      await dispatch(ACTIONS.GetCalendarEntriesByActiveVenueDetails);
      return sectionResult;
    },
    async [ACTIONS.PostCalendarDatesByDateList]({ commit, dispatch }, entryCommand) {
      //commit(MUTATIONS.IsLoadingActiveVenue, true);

      var calendarDatesByDateList = {
        dates: entryCommand.dates,
        priority: 0
      };

      const result = await apiPostCalendarDatesByDateList.patch(entryCommand.calenderEntryId, calendarDatesByDateList);
      //commit(MUTATIONS.IsLoadingActiveVenue, false);
      await dispatch(ACTIONS.GetCalendarEntriesByActiveVenueDetails);
      return result;
    },
    async [ACTIONS.AddTable]({ dispatch }, addTableCommand) {
      //commit(MUTATIONS.IsLoadingActiveVenue, true);

      //Next, create the setup
      var table = {
        name: addTableCommand.name,
        seatCount: addTableCommand.seatCount,
        venueTableType: 1,
        note: addTableCommand.note,
        combinationTablePartIds: addTableCommand.combinationTablePartIds
      }

      //const tableResult =
      await apiPostTable.post(addTableCommand.venueSetupId, addTableCommand.venueSectionId, table);
      //table.id = tableResult.id;
      //commit(MUTATIONS.IsLoadingActiveVenue, false);
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      return table;
    },
    async [ACTIONS.DeleteTable]({ commit, dispatch }, deleteTablesCommand) {
      const tableDeleteResult = await apiDeleteTable.del(deleteTablesCommand.setupId, deleteTablesCommand.sectionId, deleteTablesCommand.tableId);
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      return tableDeleteResult;
    },
    async [ACTIONS.DeleteSection]({ commit, dispatch }, deleteSectionCommand) {
      const sectionDeleteResult = await apiDeleteSection.del(deleteSectionCommand.setupId, deleteSectionCommand.sectionId);
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      return sectionDeleteResult;
    },
    async [ACTIONS.DeleteSetup]({ commit, dispatch }, deleteSetupCommand) {
      const setupDeleteResult = await apiDeleteSetup.del(deleteSetupCommand.setupId);
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);
      return setupDeleteResult;
    },
    async [ACTIONS.MoveTables]({ commit, dispatch }, moveTablesCommand) {
      //commit(MUTATIONS.IsLoadingActiveVenue, true);
      var setupId = moveTablesCommand.setupId;
      var moveToSectionId = moveTablesCommand.moveToSection.id;

      for (const section of moveTablesCommand.tableSelects) {
        var sectionId = section.sectionId;

        for (const table of section.tables) {
          try {
            const tableDeleteResult = await apiDeleteTable.del(setupId, sectionId, table.table.id);
          }
          catch (err) {
            //commit(MUTATIONS.IsLoadingActiveVenue, false);
            throw err;
          }
          const tableAddResult = await apiPostTable.post(setupId, moveToSectionId, table.table);
          // table.table.id = tableAddResult.id;
          // section.section.venueTables.splice(section.section.venueTables.indexOf(table.table), 1);
          // moveTablesCommand.moveToSection.venueTables.push(table.table);
        }
      }
      await dispatch(ACTIONS.GetVenueSetupsForActiveVenueDetails);

      //commit(MUTATIONS.IsLoadingActiveVenue, false);
    },
    async [ACTIONS.SwapCalendarEntries]({ commit, dispatch }, swapCalendarEntriesCommand) {
      const swapCalendarEntriesResult = await apiSwapCalendarEntries.patch(swapCalendarEntriesCommand.calendarEntry1, swapCalendarEntriesCommand.calendarEntry2);

      await dispatch(ACTIONS.GetCalendarEntriesByActiveVenueDetails);

      return swapCalendarEntriesResult;
    },
    async [ACTIONS.GetCountryCodes]({ commit }) {
      const result = await apiGetCountryCodes.get();
      commit(MUTATIONS.GotCountryCodes, result);
    },
    async [ACTIONS.GetTimeZonesByCountryCode]({ commit }, countryCode) {
      const result = await apiGetTimeZonesByCountryCode.get(countryCode.code);
      return result;
    },
    async [ACTIONS.PostCreateReservationsPdf]({ commit }, bookingIds) {
      const result = await apiPostCreateReservationsPdf.post(bookingIds.map(bi => bi.id));

      return result;
    },
    async [ACTIONS.GetBookingPercentageMonth]({ commit }, { venueDetailsId, year, month }) {
      const result = await apiGetBookingPercentageMonth.get(venueDetailsId.id, year, month);
      return result;
    },
    async [ACTIONS.GetBookingPercentageByDateAndVenueDetailIds]({ commit }, { date, venueDetailsIds }) {
      const ids = venueDetailsIds.map(v => v.id);
      const result = await apiPostBookingPercentageByVenues.post(date, ids);
      return result;
    }
  }
};


